import type { SearchActionEntity } from '@ok/interfaces/search/SearchActionEntity';

export enum ActionType {
    SHOW = 0,
    CLICK = 1,
}

export enum EventType {
    feedActions = 'FEED_ACTIONS',
    customActions = 'CUSTOM_ACTIONS',
}

export enum Type {
    thirdColumn = 'THIRD_COLUMN_PORTLET',
    schoolFriendsSearch = 'SCHOOL_FRIENDS',
    communityPrediction = 'COMMUNITY_PREDICTION',
    hiddenFeedRecommendations = 'HIDDEN_FEED_RECOMMENDATIONS',
    searchResult = 'SEARCH_RESULT',
    pymkThirdColumn = 'PYMK',
    todayPage = 'TODAY_PAGE',
    collection = 'COLLECTION',
}

export enum PortletLocation {
    thirdColumn = 'thirdColumn',
    feed = 'FEED',
}

export interface IFeedActionsEvent {
    actionTypeId: ActionType;
    portletLogInfo: string;
    portletLocation: PortletLocation;
    target: string;
    position: number;
    durationMs?: number;
    type?: Type;
}

export interface ICustomActionsEvent extends Record<string, any> {}

interface IPartialFeedActionsEvent extends Pick<IFeedActionsEvent, 'actionTypeId' | 'portletLogInfo' | 'type'>, Partial<Omit<IFeedActionsEvent, 'actionTypeId' | 'portletLogInfo' | 'type'>> {
    customData?: unknown;
}

export const SEEN_LOG = 'seen';
export const CLICK_LOG = 'click';

export const DATA_SEND_INTERVAL = 500;
export const MIN_VISIBLE_TIME_TO_LOG = 200;
export const NECESSARY_ELEMENT_VISIBILITY = 0.6;
export const DEFAULT_TIMEOUT_INTERVAL = 10000;

export const getFeedActionsEventLogData = ({ type, portletLogInfo, portletLocation, actionTypeId, target, durationMs, position = 0 }: IPartialFeedActionsEvent): IFeedActionsEvent => ({
    actionTypeId,
    portletLogInfo,
    portletLocation: portletLocation ? portletLocation : PortletLocation.thirdColumn,
    target: target ? target || '' : 'show',
    durationMs,
    position,
    type,
});

export const processAndSendEventLogData = (params: IPartialFeedActionsEvent) => {
    const data = params.customData ? params.customData : getFeedActionsEventLogData(params);
    const isShow = params.actionTypeId === ActionType.SHOW;
    const addLog = (window as any).OK.logger.repository.addLog;

    if (isShow) {
        addLog(SEEN_LOG, undefined, null, null, null, params.type, JSON.stringify(data));
    } else {
        addLog(CLICK_LOG, undefined, null, null, null, JSON.stringify([data]));
    }
};

/**
 * см. SearchAction в one.app.community.control.event.search.stat
 */
export enum SearchAction {
    CLICK = 'CLICK',
    SHOW = 'SHOW',
    QUERY = 'QUERY',
    JOIN = 'JOIN',
    STAT = 'STAT',
    INVITE = 'INVITE',
    REMOVE_BOOKMARK = 'REMOVE_BOOKMARK',
    ADD_BOOKMARK = 'ADD_BOOKMARK',
    MESSAGE = 'MESSAGE',
    SUBSCRIBE = 'SUBSCRIBE',
    UNSUBSCRIBE = 'UNSUBSCRIBE',
    ACCEPT = 'ACCEPT',
    CANCEL = 'CANCEL',
    BIRTHDAY_PRESENT = 'BIRTHDAY_PRESENT',
    GROUP_INVITE = 'GROUP_INVITE',
    PRESENT = 'PRESENT',
    INFO = 'INFO',
    CALL = 'CALL',
    EXPAND = 'EXPAND',
    DELETE = 'DELETE',
    COMPLETE = 'COMPLETE',
    RENDER = 'RENDER',
}

export interface ISearchActionsEvent {
    action: SearchAction;
    qid?: string;
    position?: number;
    entityId: string;
    stringEntityId: string;
    entity: SearchActionEntity;
    location?: string;
    card?: string;
    item?: string;
    positionInRelated?: number;
    positionInBestMatch?: number;
    target: string;
    query?: string;
    scope?: string;
}

export const getSearchActionsEventLogData = ({ action, qid, position, entityId, stringEntityId, entity, location, card, item, positionInRelated, positionInBestMatch, target, query, scope}: ISearchActionsEvent): ISearchActionsData => ({
    action,
    qid,
    position,
    entityId,
    stringEntityId,
    entity,
    location,
    card,
    item,
    positionInRelated,
    positionInBestMatch,
    target,
    query,
    scope,
});

interface ISearchActionsData extends Pick<ISearchActionsEvent, "action" | "qid" | "position" | "entityId" | "stringEntityId" | "entity" | "location" | "card" | "item" | "positionInRelated" | "positionInBestMatch" | "target" | "query" | "scope"> {
    customData?: unknown;
}

export const processAndSendSearchEventLogData = (params: ISearchActionsData): void => {
    const addLog = (window as any).OK.logger.repository.addLog;

    const data = JSON.stringify(params);

    addLog(SEEN_LOG, undefined, null, null, null, Type.searchResult, data);
};
